export const loginTo = {
  PUBLICA: () =>
    (`https://consignet.app-csg.com.br`),
  PRIVADA: () =>
    (`https://mixtra.app-csg.com.br`),
  DEV: () =>
    (`http://localhost:5000`),
  HOMOLOG: (type, number) =>
    (`https://homolog${number}-${type}.app-csg.com.br`),
  IMPLANTACAO: (type)  =>
    (`https://implantacao-${type}.app-csg.com.br`),
};
